const TwoFactorAuthMethods = {
  GOOGLE_AUTHENTICATOR: 'GOOGLE_AUTHENTICATOR',
  SMS: 'SMS',
  HUBSPOT_AUTHENTICATOR: 'HUBSPOT_AUTHENTICATOR',
  BACKUP: 'BACKUP'
};
export default TwoFactorAuthMethods;